import { useEffect, useRef } from 'react';

/* Ожидание ИИ: знак прыгает через скакалку (анимация «Скакалка» из prototype/logo-lottie, цикл 2,2 с).
   lottie и сама анимация грузятся только когда ждём — в основной бандл не попадают. */
export function RopeAnim({ size }: { size: number }) {
  const box = useRef<HTMLSpanElement>(null);
  useEffect(() => {
    let anim: { destroy(): void } | null = null;
    let dead = false;
    Promise.all([import('lottie-web/build/player/lottie_light'), import('./rope.lottie.json')]).then(([L, data]) => {
      if (dead || !box.current) return;
      const still = window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;
      const a = L.default.loadAnimation({ container: box.current, renderer: 'svg', loop: true, autoplay: !still, animationData: JSON.parse(JSON.stringify(data.default)) });
      if (still) a.goToAndStop(40, true);
      anim = a;
    });
    return () => {
      dead = true;
      anim?.destroy();
    };
  }, []);
  return <span ref={box} className="rope-anim" style={{ width: size, height: size }} aria-hidden />;
}

/** Поверх блока текстом, пока ИИ разбирает */
export function AiWait({ text }: { text: string }) {
  return (
    <div className="ai-wait" role="status">
      <RopeAnim size={130} />
      <span>{text}</span>
    </div>
  );
}
